var UbpEdizioni = (function () {

  // ---------------------------------------------------------------------------
  // ID EDIZIONE DA ANNO EDIZIONE
  var idEdizione = function (annoEdizione) {

    // -----------------------------------
    // anno ultima edizione (allineare a rw_edizioni::$corrente in inc/ubp/ubp_classes.php)
    var lastYear = 2026;
    // id ubp 2014, prima edizione
    var the_id = 4;

    var the_blog_id;
    var language = $('html').attr('lang');

    for (i = 2014; i < lastYear + 1; i++) {
      if(annoEdizione == i){
        if (language == 'it-IT') { the_blog_id = the_id; }
        else if (language == 'en-US') { the_blog_id = the_id + 1; }
      }
      the_id = the_id + 2;
    }

    return the_blog_id;

  };


  return {
    idEdizione : idEdizione
  }


})();
